module.exports = __webpack_public_path__ + "fonts/icomoon.353e2d9.ttf";